import type {UseFormReturn} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import AnyResidentInput from '@/shared/residents/components/AnyResidentInput';

import type {ExportOptionsFieldsProps} from '../../types/exportTypes';
import type {ExportFormValues} from '../../utils/exportFormInputs';
import type {ResidentOptions} from '../../utils/exportOptions';

const ResidentOptionsFields = <TOptions extends ResidentOptions>({
  form,
}: ExportOptionsFieldsProps<TOptions>) => {
  const {t} = useTranslation();
  // UseFormReturn is invariant, so a parent form with wider options needs this cast
  const {control} = form as unknown as UseFormReturn<
    ExportFormValues<ResidentOptions>
  >;

  return (
    <FormField
      control={control}
      name="options.residentId"
      render={({field}) => (
        <FormItem>
          <FormLabel required>{t('Resident')}</FormLabel>
          <FormControl>
            <AnyResidentInput
              value={field.value}
              onChange={field.onChange}
              inputProps={{placeholder: t('Select a resident')}}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default ResidentOptionsFields;
